/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Gazconso1Inputs */



/**
* | output |
* | --- |
* | "Gas consumption" |
*
* @param {Br_History_Key_Gazconso1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_gazconso1 = /** @type {((inputs?: Br_History_Key_Gazconso1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Gazconso1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Gas consumption")
	return /** @type {LocalizedString} */ ("Consommation de gaz")
});
export { br_history_key_gazconso1 as "br_history_key_gazConso" }